var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KOptionalText',{attrs:{"text":_vm.seconds !== null ? _vm.formattedTime : ''}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }